import { FormControlOptions, ValidatorFn } from '@angular/forms';

export interface FieldBaseParam<T> {
  value?: T;
  order?: number;
  controlType?: string;
  validatorOrOpts?: ValidatorFn | ValidatorFn[] | FormControlOptions | null;
  key?: string;
  settings?: FieldSettings;
}

export class FieldBase<T> {
  key?: string;
  value: T | undefined;
  order: number;
  controlType: string;
  validatorOrOpts: ValidatorFn | ValidatorFn[] | FormControlOptions | null;
  settings?: FieldSettings;

  constructor(options: FieldBaseParam<T> = {}) {
    this.value = options.value;
    this.order = options.order ?? 1;
    this.controlType = options.controlType ?? '';
    this.validatorOrOpts = options.validatorOrOpts ?? {};
    this.key = options.key ?? '';
    this.settings = options.settings ?? {};
  }
}

export interface FieldSettings {
  label?: string;
  placeholder?: string;
  required?: boolean;
}

export interface DropdownOption {
  value: string;
  codeId: string;
}

export interface Selection {
  score: number;
  label: string;
}

export interface FormScore {
  totalScore: number;
  sectionSummaries: Record<string, number>;
}
